import * as yup from "yup";
import validationValues from "../values";

const loginSchema = yup.object().shape({
  email: validationValues.email,
  password: validationValues.password,
});

export default loginSchema;
